import React, { FunctionComponent } from "react";
import { GoalInfo } from '/src/domain/challenges/ChallengeProtocolData';
import {
  Typography,
  LinearProgress,
  LinearProgressProps,
  linearProgressClasses,
  styled,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import cs from "classnames";
import { useTranslation } from "react-i18next";
import { theme } from "/src/assets/theme";

export type SystemMessageProps = {
    className?: string;
    message: string;
    goalInfo?: GoalInfo;
};

export const SystemMessage: FunctionComponent<SystemMessageProps> = ({
    className,
    message,
    goalInfo,
}) => {
    const { t } = useTranslation();
    const classes = useStyles();

    if (!message) return null;

    return (<div className={cs(className, classes.container)}>
        <Typography variant="h6" color="primary">{message}</Typography>
        {goalInfo && <ProgressBar goalInfo={goalInfo} />}
    </div>);
};

interface ProgressBarProps {
    goalInfo: GoalInfo;
}

const ProgressBar: FunctionComponent<ProgressBarProps> = ({
    goalInfo
}) => {
    const isOverfulfilled = goalInfo.percentage > 100;
    const percentage = isOverfulfilled
      ? (100 / goalInfo.percentage) * 100
      : goalInfo.percentage;

    const classes = useStyles();
    return (<div className={classes.progressContainer}>
        <Typography className={classes.rate}>{goalInfo.percentage}%</Typography>
        <BorderLinearProgress
            color="primary"
            sx={{
                backgroundColor: isOverfulfilled ? theme.lightGreenColor : undefined,
            }}
            variant="determinate"
            value={percentage}
        />
    </div>)
}

const BorderLinearProgress = styled(LinearProgress)<LinearProgressProps>((props) => ({
    marginTop: "0.75rem",
    height: "1.5rem",
    borderRadius: 99,
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 99,
    },
}));

const useStyles = makeStyles({
    container: {
        padding: "2rem 3rem",
        backgroundColor: theme.lightPrimaryColor,
        borderRadius: "10px",
        margin: "2rem 1.5rem"
    },
    progressContainer: {
        position: "relative"
    },
    rate: {
        position: "absolute",
        zIndex: 1,
        left: "50%",
        top: "0.35rem",
        fontSize: "0.9rem",
        lineHeight: "0.9rem",
        fontWeight: 500,
        transform: "translateX(-50%)",
        color: theme.WHITE_COLOR,
    }
})